// extracted by mini-css-extract-plugin
module.exports = {"freeform":"ScheduleLegend_freeform__PzVUF","specialty":"ScheduleLegend_specialty__Indsq","cp":"ScheduleLegend_cp__DzAUB","container":"ScheduleLegend_container__pB6Is"};